module.exports = __webpack_public_path__ + "img/experience14.0a5499e7.jpg";